import { FC } from 'react';
// Models
import IQuiz from 'models/Quiz';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectQuestionReady } from 'store/player/playerSelectors';
import { MdOutlineTimer } from "react-icons/md";

type Props = {
  width: number;
}

const QuestionScoringBar:FC<Props> = ({ width }) => {
  const quiz:IQuiz = useAppSelector(selectQuiz);
  const questionReady:boolean = useAppSelector(selectQuestionReady);

  if ( !questionReady || !quiz.questionsSettings.timeout ) return null;
  return (
    <div>
      <div
        className="relative h-full bg-gray-200 border-4 border-gray-200 w-6 rounded-lg"
        style={{ marginBottom: 2 }}
      >
        <div className="absolute top-0 left-0 h-full w-4 opacity-25 rounded z-0" style={{ backgroundColor: quiz.theme.progressBarColor }}></div>
        <div className="absolute bottom-0 left-0 w-4 rounded z-10" style={{ height: `${width}%`, backgroundColor: quiz.theme.progressBarColor }}>
          <MdOutlineTimer className="absolute bottom-1 text-white" />
        </div>
      </div>
    </div>
  )
}

export default QuestionScoringBar;
